<ng-template #header>
  <ng-content select="[app-tab-header]"></ng-content>
</ng-template>

<ng-template #content>
  <ng-content select="[app-tab-content]"></ng-content>
</ng-template>
